import { render, staticRenderFns } from "./ForgotPasswordVerification.vue?vue&type=template&id=05d85451&scoped=true"
import script from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordVerification.vue?vue&type=style&index=0&id=05d85451&prod&lang=scss&scoped=true"
import style1 from "./ForgotPasswordVerification.vue?vue&type=style&index=1&id=05d85451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d85451",
  null
  
)

export default component.exports